// Deprecated. Please refrain from new usage
import PropTypes from "prop-types";
import React from "react";
import { withTheme } from "@material-ui/core/styles";

const ScrollFadeIndicator = (props) => {
  const { theme, style, direction } = props;
  return (
    <div
      style={{
        position: "absolute",
        [direction]: 0,
        top: 0,
        height: props.style.height,
        background: `linear-gradient(to ${direction}, rgba(0,0,0,0) 1px, ${theme.palette.background.paper} 60%`,
        width: 20,
        ...style,
      }}
    />
  );
};

ScrollFadeIndicator.propTypes = {
  style: PropTypes.shape({ height: 0 }),
  direction: PropTypes.oneOf(["left", "right"]),
  theme: PropTypes.object.isRequired,
};

ScrollFadeIndicator.defaultProps = {
  style: {
    height: "100%",
  },
  direction: "right",
};

export default withTheme(ScrollFadeIndicator);
